import React from 'react'
import Header from '../common/header/Header'
import { BrowserRouter as Router , Routes, Route} from "react-router-dom";
import Home from '../home/Home'
import About from "../about/About"
import Pricing from "../pricing/Pricing"
import Contact from '../contact/Contact'
import Footer from '../common/footer/Footer'

const Pages = () => {
  return (
    <>
    <Router>
      <Header/>
        <Routes>
          <Route exact path='/' Component={Home} />
          <Route exact path='about' Component={About}/>
          <Route exact path='pricing' Component={Pricing}/>
          <Route exact path='contact' Component={Contact}/>
        </Routes>
        <Footer/>
    </Router>
    </>
  )
}

export default Pages